import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
import Userauth from "../auth/js/index";

import Body from "../components/body";
import Auth from "../auth/auth";

/* Auth */
import login from "../auth/login";
import Register from "../auth/register";
import resetPassword from '../auth/reset-password.vue'

// import Register from "../pages/authentication/register_image2";

/* maintenance */
import Maintenance from "../pages/maintenance";

/* Error Pages */
import Error400 from "../errors/error_400";
import Error401 from "../errors/error_401";
import Error403 from "../errors/error_403";
import Error404 from "../errors/error_404";
import Error500 from "../errors/error_500";
import Error503 from "../errors/error_503";

/* comingsoon */
import ComingsoonSimple from "../pages/comingsoon/comingsoon_simple";
import ComingsoonImage from "../pages/comingsoon/comingsoon_image";
import ComingsoonVideo from "../pages/comingsoon/comingsoon_video";

/* Authentication */
import LoginOne from "../pages/authentication/login_one";
import LoginTwo from "../pages/authentication/login_two";
import LoginValidate from "../pages/authentication/login_with_validation";
import RegisterImage from "../pages/authentication/register_image";
import RegisterImage2 from "../pages/authentication/register_image2";
import Unlock from "../pages/authentication/unlock";
import ForgetPassword from "../pages/authentication/forget_password";
import ResetPassword from "../pages/authentication/reset_password";

// Notifier
import SendSms from "../notifier/smsManagement/sendSms"
import DynamicSms from "../notifier/smsManagement/dynamicSms"
import SmsTemplate from "../notifier/smsTemplate/smsTemplate"
import PriceAndCoverage from "../notifier/priceAndCoverage/priceAndCoverage"
import ContactGroup from "../notifier/addressBook/contactGroup"
import ManageContact from "../notifier/addressBook/manageContact"
import Billing from "../notifier/billing/billing"
import TodaysReport from "../notifier/deliveryReport/todaysDeliveryReport"
import AllReport from "../notifier/deliveryReport/allTimeDeliveryReport"
import ChangePassword from "../notifier/user/changePassword"
import ApiDocumentation from "../notifier/documentation/apiDocumentation"


// Dashboard
import Dashboard from "../pages/project-doc/dashboard/dashboard.vue";
import shelterDashboard from "../pages/project-doc/dashboard/shelter-dashboard.vue";

// RDRC
import Team from "../pages/project-doc/about/team.vue";
import About from "../pages/project-doc/about/about.vue";
import Partner from "../pages/project-doc/about/partner.vue";
import Involvement from "../pages/project-doc/about/involvement.vue";
import Setting from "../pages/project-doc/settings/site-settings.vue";
import Policy from "../pages/project-doc/settings/policy.vue";
import Message from "../pages/project-doc/contact/message.vue";
import Subscriber from "../pages/project-doc/contact/subscriber.vue";
import Notice from "../pages/project-doc/settings/notice.vue";
import Expertise from "../pages/project-doc/content/expertise.vue";
import CoProduction from "../pages/project-doc/content/co-production.vue";
import News from "../pages/project-doc/content/news.vue";
import Research from "../pages/project-doc/research/research/research.vue";
import ResearchCategory from "../pages/project-doc/research/category/category.vue";
import Publication from "../pages/project-doc/publication/publication/publication.vue";
import PublicationCategory from "../pages/project-doc/publication/category/category.vue";
import Advocacy from "../pages/project-doc/advocacy/advocacy/advocacy.vue";
import AdvocacyCategory from "../pages/project-doc/advocacy/category/category.vue";
import JobCreate from "../pages/project-doc/job/create.vue";
import Job from "../pages/project-doc/job/job.vue";
import JobDetail from "../pages/project-doc/job/edit.vue";
import Applicant from "../pages/project-doc/job/applicant.vue";
import Home from "../pages/project-doc/home/banner.vue";
import CustomUI from '../pages/project-doc/custom/custom.vue';

// Empowerment
import InTheirOwnWords from "../pages/empowerment/own-words/words.vue";
import Gallery from "../pages/empowerment/gallery/gallery.vue";
import MotionStories from "../pages/empowerment/motion-stories/stories.vue";
import Submission from "../pages/empowerment/student-submission/submission.vue";
import SubmissionDetails from "../pages/empowerment/student-submission/details.vue";

import {store} from "@/store";

Vue.use(Router);

const routes = [
    // Project Doc
    { path: "", redirect: "/dashboard/main" },
    { path: "/dashboard", redirect: "/dashboard/main" },

    {
        path: "/dashboard",
        component: Body,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: "main",
                name: "dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            },
            {
                path: "",
                name: "dashboard",
                component: Dashboard,
                meta: {
                    title: "Dashboard"
                }
            },
            {
                path: "shelter",
                name: "shelterDashboard",
                component: shelterDashboard,
                meta: {
                    title: "Shelter Dashboard"
                }
            }
        ]
    },

    // {
    //     path: "/about",
    //     component: Body,
    //     meta: {
    //         requiresAuth: true
    //     },
    //     children: [
    //         {
    //             path: "partner",
    //             name: "Partner",
    //             component: Partner,
    //             meta: {
    //                 title: "Partner"
    //             }
    //         },
    //         {
    //             path: "team",
    //             name: "Team",
    //             component: Team,
    //             meta: {
    //                 title: "Team"
    //             }
    //         },
    //         {
    //             path: "about",
    //             name: "About",
    //             component: About,
    //             meta: {
    //                 title: "About"
    //             }
    //         },
    //         {
    //             path: "involvement",
    //             name: "Involvement",
    //             component: Involvement,
    //             meta: {
    //                 title: "Involvement"
    //             }
    //         },
    //     ]
    // },

    // {
    //     path: "/contact",
    //     component: Body,
    //     meta: {
    //         requiresAuth: true
    //     },
    //     children: [
    //         {
    //             path: "message",
    //             name: "Message",
    //             component: Message,
    //             meta: {
    //                 title: "Message"
    //             }
    //         },
    //         {
    //             path: "subscriber",
    //             name: "Subscriber",
    //             component: Subscriber,
    //             meta: {
    //                 title: "Subscriber"
    //             }
    //         }
    //     ]
    // },

    // {
    //     path: "/career",
    //     component: Body,
    //     meta: {
    //         requiresAuth: true
    //     },
    //     children: [
    //         {
    //             path: "job/create",
    //             name: "JobCreate",
    //             component: JobCreate,
    //             meta: {
    //                 title: "Create Job"
    //             }
    //         },
    //         {
    //             path: "job/list",
    //             name: "Job",
    //             component: Job,
    //             meta: {
    //                 title: "Job"
    //             }
    //         },
    //         {
    //             path: "job/update/:id",
    //             name: "JobDetail",
    //             component: JobDetail,
    //             meta: {
    //                 title: "Update Job"
    //             }
    //         },
    //         {
    //             path: "job/applicant",
    //             name: "Applicant",
    //             component: Applicant,
    //             meta: {
    //                 title: "Applicant"
    //             }
    //         }
    //     ]
    // },

    // {
    //     path: "/setting",
    //     component: Body,
    //     meta: {
    //         requiresAuth: true
    //     },
    //     children: [
    //         {
    //             path: "notice",
    //             name: "Notice",
    //             component: Notice,
    //             meta: {
    //                 title: "Notice"
    //             }
    //         },
    //         {
    //             path: "site-setting",
    //             name: "Setting",
    //             component: Setting,
    //             meta: {
    //                 title: "Setting"
    //             }
    //         },
    //         {
    //             path: "policy",
    //             name: "Policy",
    //             component: Policy,
    //             meta: {
    //                 title: "Policy"
    //             }
    //         }
    //     ]
    // },
    {
        path: "/submission",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "student-submissions",
                name: "Submission",
                component: Submission,
                meta: {
                    title: "Student Submissions"
                }
            },
            {
                path: "student-submission/:id",
                name: "SubmissionDetails",
                component: SubmissionDetails,
                meta: {
                    title: "Student Submissions"
                }
            }
        ]
    },

    {
        path: "/content",
        component: Body,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "in-their-own-words",
                name: "InTheirOwnWords",
                component: InTheirOwnWords,
                meta: {
                    title: "In their Own Words"
                }
            },
            {
                path: "gallery",
                name: "Gallery",
                component: Gallery,
                meta: {
                    title: "Gallery"
                }
            },
            {
                path: "stories-in-motion",
                name: "MotionStories",
                component: MotionStories,
                meta: {
                    title: "Stories in Motion"
                }
            },
            // {
            //     path: "home/banner",
            //     name: "Home",
            //     component: Home,
            //     meta: {
            //         title: "Home"
            //     }
            // },
            // {
            //     path: "expertise",
            //     name: "Expertise",
            //     component: Expertise,
            //     meta: {
            //         title: "Expertise"
            //     }
            // },
            // {
            //     path: "co-production-lab",
            //     name: "CoProduction",
            //     component: CoProduction,
            //     meta: {
            //         title: "CoProduction Lab"
            //     }
            // },
            // {
            //     path: "news",
            //     name: "News",
            //     component: News,
            //     meta: {
            //         title: "News"
            //     }
            // },
            // {
            //     path: "research/list",
            //     name: "Research",
            //     component: Research,
            //     meta: {
            //         title: "Research"
            //     }
            // },
            // {
            //     path: "research/category",
            //     name: "ResearchCategory",
            //     component: ResearchCategory,
            //     meta: {
            //         title: "Research Category"
            //     }
            // },
            // {
            //     path: "publication/list",
            //     name: "Publication",
            //     component: Publication,
            //     meta: {
            //         title: "Publication"
            //     }
            // },
            // {
            //     path: "publication/category",
            //     name: "PublicationCategory",
            //     component: PublicationCategory,
            //     meta: {
            //         title: "Publication Category"
            //     }
            // },
            // {
            //     path: "advocacy/list",
            //     name: "Advocacy",
            //     component: Advocacy,
            //     meta: {
            //         title: "Advocacy"
            //     }
            // },
            // {
            //     path: "advocacy/category",
            //     name: "AdvocacyCategory",
            //     component: AdvocacyCategory,
            //     meta: {
            //         title: "Advocacy Category"
            //     }
            // }
        ]
    },

    // Custom UI
    // {
    //     path: '/custom-ui/:type/:id',
    //     name: 'CustomUI',
    //     component: CustomUI,
    //     meta: {
    //         login_required: true,
    //         hideSidebar: false
    //     }
    // },



    //Notifier
    {
        path: "/auth",
        component: Auth,
        children: [
            {
                path: "login",
                name: "Login 1",
                component: login,
                meta: {
                    title: " login",
                }
            },
            {
                path: "register",
                name: "register 1",
                component: Register,
                meta: {
                    title: " Register | Ambala",
                }
            },
            {
                path: "reset-password",
                name: "Reset Password",
                component: resetPassword,
                meta: {
                    title: " Reset Password"
                }
            }
        ]
    },

    //Notifier -end
    // {
    //     path: "/dashboard",
    //     component: Body,
    //     meta: {
    //         requiresAuth: true,
    //     },
    //     children: [
    //         {
    //             path: "default",
    //             name: "default",
    //             component: Default,
    //             meta: {
    //                 title: "Default Dashboard | Cuba - Premium Admin Template",
    //             }
    //         },
    //         {
    //             path: "ecommerce",
    //             name: "ecommerce",
    //             component: Ecommerce,
    //             meta: {
    //                 title: "Ecommerce Dashboard | Cuba - Premium Admin Template",
    //             }
    //         }
    //     ],
    // },

    {
        path: "/error-400",
        name: "Error400",
        component: Error400,
        meta: {
            title: "Error400 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-401",
        name: "Error401",
        component: Error401,
        meta: {
            title: "Error401 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-403",
        name: "Error403",
        component: Error403,
        meta: {
            title: "Error403 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-404",
        name: "Error404",
        component: Error404,
        meta: {
            title: "Error404 | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/error-500",
        name: "Error500",
        component: Error500,
        meta: {
            title: "Error500 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/error-503",
        name: "Error503",
        component: Error503,
        meta: {
            title: "Error503 | Cuba - Premium Admin Template",
        }
    },

    {
        path: "/maintenance",
        name: "Maintenance",
        component: Maintenance,
        meta: {
            title: "Maintenance | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-simple",
        name: "ComingsoonSimple",
        component: ComingsoonSimple,
        meta: {
            title: "ComingsoonSimple | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-image",
        name: "ComingsoonImage",
        component: ComingsoonImage,
        meta: {
            title: "ComingsoonImage | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/comingsoon/comingsoon-video",
        name: "ComingsoonVideo",
        component: ComingsoonVideo,
        meta: {
            title: "ComingsoonVideo | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/one",
        name: "LoginOne",
        component: LoginOne,
        meta: {
            title: "LoginOne | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/two",
        name: "LoginTwo",
        component: LoginTwo,
        meta: {
            title: "LoginTwo | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/login/validate",
        name: "LoginValidate",
        component: LoginValidate,
        meta: {
            title: "LoginValidate | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/register/image",
        name: "RegisterImage",
        component: RegisterImage,
        meta: {
            title: "RegisterImage | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/register/image2",
        name: "RegisterImage2",
        component: RegisterImage2,
        meta: {
            title: "RegisterImage2 | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/unlockuser",
        name: "Unlock",
        component: Unlock,
        meta: {
            title: "Unlock | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/forgetpassword",
        name: "ForgetPassword",
        component: ForgetPassword,
        meta: {
            title: "ForgetPassword | Cuba - Premium Admin Template",
        }
    },
    {
        path: "/authentication/resetpassword",
        name: "ResetPassword",
        component: ResetPassword,
        meta: {
            title: "ResetPassword | Cuba - Premium Admin Template",
        }
    }
];

const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: "history",
    linkActiveClass: "active",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

router.beforeEach((to, from, next) => {
    // console.log("started")
    if (to.meta.title) document.title = to.meta.title;
    let CurrentUser = localStorage.getItem('user') == null ? false : true;

    const allowedPaths = [
        "/auth/login",
        "/auth/register",
        "/auth/reset-password",
        "/auth/reset"
    ];

    const notAllowedWhenLoggedIn =[
        "/auth/login",
        "/auth/register",
        "/auth/reset-password",
        "/auth/reset"
    ];

    const JWTuser = localStorage.getItem("user");

    const matchPath = (path) => {
        return allowedPaths.some(allowedPath => {
            if (allowedPath.includes(":")) {
                const regexPath = allowedPath.replace(/:\w+/g, "\\w+");
                const regex = new RegExp(`^${regexPath}$`);
                return regex.test(path);
            }
            return allowedPath === path;
        });
    };

    // console.log("started22")
    // console.log(to.path)

    if ( matchPath(to.path)){
        console.log("allowed path")
        if(notAllowedWhenLoggedIn.includes(to.path)) {
            if(CurrentUser)
                return next({
                    path: '/dashboard/main',
                });
        }
        return next()
    }else{
        store.dispatch('authentication/verify_token', localStorage.getItem("access_token")).then(result=>{
            console.log("after verify", result)
        })
    }

    if( to.path === "/callback" ||
        CurrentUser ||
        Userauth.isAuthenticatedUser() ||
        JWTuser
    ) {
        return next();
    }

    next({
        path: '/auth/login',
        query: { redirect: to.fullPath }
    });
});

export default router;
